import { createContext, useContext } from 'react';

import type { GetCurrentEmployeePermissionAccessFlagEmployeeQuery, GetCurrentEmployeeQuery } from '../graphql';
import { EmployeeDetail, type EmployeeDetailType } from '../types';

export const EmployeeDetailContextInitialState = EmployeeDetail.parse({});

export type EmployeeDetailContextType = {
  employeeDetail: EmployeeDetailType;
  setEmployeeDetail: (employee: EmployeeDetailType) => void;
  currentEmployee: GetCurrentEmployeeQuery['currentEmployee'] | null;
  currentEmployeeLoading: boolean;
  currentEmployeeAccessFlag:
    | GetCurrentEmployeePermissionAccessFlagEmployeeQuery['currentEmployee']['accessFlag']
    | null;
};

export const EmployeeDetailContext = createContext<EmployeeDetailContextType>({
  employeeDetail: EmployeeDetailContextInitialState,
  setEmployeeDetail: () => {},
  currentEmployee: null,
  currentEmployeeLoading: false,
  currentEmployeeAccessFlag: null,
});

export const useEmployeeDetailContext = (): EmployeeDetailContextType => useContext(EmployeeDetailContext);
